import { lazy } from 'react';

export const Alkozamki = lazy(() => import('./ui/Alkozamki'));
